import 'css-chunksrc/client/scenes/moveElement/projectsSelection/input/nameWithCount/styles.scss';export default {
  "name": "_name_2po58_1",
  "nameWithCount": "_nameWithCount_2po58_8",
  "count": "_count_2po58_19"
};